/**
 * Deterministic colour helpers, ported from student-hub for the v2 migration.
 * Used to give each profile avatar a stable colour derived from its name.
 */

// Generates a consistent background colour class for a given name, picking
// deterministically from `colorsList` (or a default palette) so the same name
// always maps to the same colour.
export function getColor(name: string, colorsList?: string[]): string {
  const colors = colorsList ?? [
    'bg-blue-500',
    'bg-purple-500',
    'bg-pink-500',
    'bg-rose-500',
    'bg-orange-500',
    'bg-amber-500',
    'bg-yellow-500',
    'bg-lime-500',
    'bg-green-500',
    'bg-emerald-500',
    'bg-teal-500',
    'bg-cyan-500',
    'bg-sky-500',
    'bg-indigo-500',
    'bg-violet-500',
    'bg-fuchsia-500',
  ];

  // Simple hash function to generate a consistent index from the string.
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }

  const index = Math.abs(hash) % colors.length;
  return colors[index];
}

// Returns a readable text colour class for a given background colour class:
// light backgrounds use black text, everything else uses white.
export function getTextColorForBg(bgColor: string, lightColorBg: string[]): string {
  return lightColorBg.includes(bgColor) ? 'text-black' : 'text-white';
}
